import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/api';

/**
 * Sign-out (spec 10 §6): revokes the session, drops every cached query and
 * goes to `/sign-in`. A `401` means the session was already gone — same end.
 */
export function useSignOut() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async () => {
      const { response } = await api.DELETE('/v1/sessions/current');
      if (!response.ok && response.status !== 401) throw new Error(`sign-out answered ${response.status}`);
    },
    onSuccess: () => {
      queryClient.clear();
      navigate('/sign-in', { replace: true });
    },
  });
}
